export default __webpack_public_path__ + "images/install-tick.84e120c772ec28f33a7f615b92c9a700.png";